// import React from "react";
import React, { useRef } from "react";

import "./App.css";
import "./css/style.css";
import "./css/bootstrap.css";
import { useTraceabilityData } from "./contexts/TraceabilityDataContext";

const Products = () => {
  const batchCode = localStorage.getItem("batchCode");

  const { brandData } = useTraceabilityData();
  const { brandName, productName, marketedBy, sku } =
    brandData?.logo || {};
  const sliderRef = useRef(null);
  const image = brandData?.logo?.image;
  // console.log(image);

  const handleProductSelect = (product) => {
    alert(`Selected: ${product.name}`);
  };
  return (
    <div className="">
      {/* Wrapper2 Section */}
      <div className="wrapper2">
        <h3 className="heading2">
          Your {brandName} {productName}{" "}
        </h3>
        <p style={{ textAlign: "center", fontWeight: 500 }}>
          Everything you need to know, right here!
        </p>
      </div>

      {/* Product Details Section */}
      <section className="py-4 bg-white" id="scroll-target">
        <div className="container px-4">
          <div className="row align-items-center">
            <div className="col-5">
              <img
                className="img-fluid rounded-4"
                src={image}
                alt="..."
              />
            </div>
            <div className="col-7">
              <ul
                className="custom-bullets"
                style={{ fontSize: "13px", fontWeight: 500 }}
              >
                <li>Product Name: {productName}</li>
                <li>Brand Name: {brandName}</li>
                {/* <li>Marketed By: {marketedBy}</li> */}
                <li>SKU: {sku}</li>
                <li>Batch Code: {batchCode}</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <div className="bg-light mt-4">
        <div className="container p-3">
          <div className="underline2 my-3"></div>

          {/* Banner */}
          <div className="d-flex justify-content-center">
            <a
              href="https://www.moomark.in/products/fmcg"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src="img/Asset 83.png"
                alt="Banner"
                className="mobile-banner"
              />
            </a>
          </div>

        </div>
      </div>
    </div>
  );
};

export default Products;
